import { createReduxStore } from '#packages/apilib';

import type { SlotData } from './types';

interface SlotOpenerState {
  availableSlot: SlotData | null;
  allSlotsInContainer: SlotData[];
  shouldOpenSlot: boolean;
}

const getInitialState = (): SlotOpenerState => ({
  availableSlot: null,
  allSlotsInContainer: [],
  shouldOpenSlot: false,
});

export const SlotOpenerStore = createReduxStore({
  getInitialState,
  selectors: {
    getAvailableSlot: (state) => state.availableSlot,
    getAllSlotsInContainer: (state) => state.allSlotsInContainer,
    getShouldOpenSlot: (state) => state.shouldOpenSlot,
  },
  actions: {
    setAvailableSlot: (state: SlotOpenerState, slot: SlotData) => ({
      ...state,
      availableSlot: slot,
    }),
    setAllSlotsInContainer: (state: SlotOpenerState, slots: SlotData[]) => ({
      ...state,
      allSlotsInContainer: slots,
    }),
    setShouldOpenSlot: (state: SlotOpenerState, shouldOpenSlot: boolean) => ({
      ...state,
      shouldOpenSlot,
    }),
  },
});
